import { lazy, type ComponentType } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { incentiveBudgetsViewAccessControl } from '../access-control/incentiveBudgetsAdminAccess.configuration'

const IncentiveBudgetsListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "IncentiveBudgetsListPage" */
      '../pages/list/IncentiveBudgetsListPage'
    )
)

// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const incentiveBudgetsAdminRouter = (
  <DomainRoute
    route="app-admin-incentive-budgets"
    accessControl={incentiveBudgetsViewAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-incentive-budgets-list"
        component={IncentiveBudgetsListPage as ComponentType<any>}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
